import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/components/charts/apex-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/sections/course-variety/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/sections/professional-content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/sections/skill-combo/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/Button/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/SvgIcon/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
